import { render, staticRenderFns } from "./SidebarFilter.vue?vue&type=template&id=4a591422"
import script from "./SidebarFilter.vue?vue&type=script&lang=ts"
export * from "./SidebarFilter.vue?vue&type=script&lang=ts"
import style0 from "./SidebarFilter.vue?vue&type=style&index=0&id=4a591422&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports